import React, { useMemo, useState } from "react";
import {
  Box,
  Chip,
  InputAdornment,
  List,
  ListItemButton,
  ListItemText,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const DOMAIN_ORDER = [
  "Documentos",
  "Dashboard",
  "Config",
  "Notificaciones",
  "Email",
  "Settings",
  "API Portal",
  "Mutations",
];

function domainKey(op) {
  if (op.kind === "MUTATION" && op.domain !== "API Portal") return "Mutations";
  return op.domain;
}

export default function GraphqlOperationCatalog({ operations, selected, onSelect }) {
  const [filter, setFilter] = useState("");

  const grouped = useMemo(() => {
    const map = {};
    (operations || []).forEach((op) => {
      const key = domainKey(op);
      if (!map[key]) map[key] = [];
      map[key].push(op);
    });
    Object.values(map).forEach((list) =>
      list.sort((a, b) => a.name.localeCompare(b.name))
    );
    return map;
  }, [operations]);

  const filteredGroups = useMemo(() => {
    const q = filter.trim().toLowerCase();
    if (!q) return grouped;
    const result = {};
    Object.entries(grouped).forEach(([domain, ops]) => {
      const matches = ops.filter(
        (op) =>
          op.name.toLowerCase().includes(q) ||
          (op.description || "").toLowerCase().includes(q)
      );
      if (matches.length) result[domain] = matches;
    });
    return result;
  }, [grouped, filter]);

  const domains = DOMAIN_ORDER.filter((d) => filteredGroups[d]);

  return (
    <Box className="gql-op-catalog">
      <Box sx={{ px: 1.5, pt: 1.5, pb: 1 }}>
        <TextField
          size="small"
          fullWidth
          placeholder="Buscar operaciones…"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <List dense sx={{ flex: 1, overflow: "auto", py: 0 }}>
        {domains.map((domain) => (
          <Box key={domain}>
            <div className="gql-op-domain">{domain}</div>
            {filteredGroups[domain].map((op) => (
              <ListItemButton
                key={op.name}
                selected={selected === op.name}
                onClick={() => onSelect(op)}
              >
                <ListItemText
                  primary={op.name}
                  secondary={
                    <Chip
                      label={op.kind}
                      size="small"
                      variant="outlined"
                      sx={{ mt: 0.5, height: 20, fontSize: "0.65rem" }}
                    />
                  }
                  secondaryTypographyProps={{ component: "div" }}
                />
              </ListItemButton>
            ))}
          </Box>
        ))}
      </List>
    </Box>
  );
}
